(() => {
  document.querySelectorAll('[data-end-date][data-end-time]').forEach((banner) => {
    const target = new Date(banner.dataset.endDate + 'T' + banner.dataset.endTime).getTime();
    if(!Number.isFinite(target))return;
    const tick=()=>{
      const remaining=target-Date.now();
      if(remaining<=0){banner.querySelector('[data-timer]').style.display='none';banner.querySelector('[data-expired]').style.display='block';clearInterval(timer);return;}
      const values={days:Math.floor(remaining/86400000),hours:Math.floor(remaining%86400000/3600000),minutes:Math.floor(remaining%3600000/60000),seconds:Math.floor(remaining%60000/1000)};
      Object.entries(values).forEach(([key,value])=>{const output=banner.querySelector(`[data-${key}]`);if(output)output.textContent=String(value).padStart(2,'0');});
    };
    const timer=setInterval(tick,1000);tick();
  });
  document.querySelectorAll('header-drawer details').forEach((details)=>{
    const summary=details.querySelector('summary');
    summary?.setAttribute('role','button');
    summary?.setAttribute('aria-expanded',String(details.open));
    details.addEventListener('toggle',()=>{
      details.classList.toggle('menu-opening',details.open);
      details.querySelector('summary')?.setAttribute('aria-expanded',String(details.open));
      document.body.classList.toggle('overflow-hidden-tablet',details.open);
    });
  });
  document.querySelectorAll('.menu-drawer__close-btn').forEach((button)=>button.addEventListener('click',()=>{const details=button.closest('details');details.open=false;details.querySelector('summary')?.focus();}));
  document.querySelectorAll('details-modal .modal__close-button').forEach((button)=>button.addEventListener('click',()=>{const details=button.closest('details');details.open=false;details.querySelector('summary')?.focus();}));
  document.addEventListener('keydown',(event)=>{if(event.key==='Escape')document.querySelectorAll('header details[open]').forEach((details)=>{details.open=false;details.querySelector('summary')?.focus();});});
  document.querySelectorAll('nav a[href]').forEach((anchor)=>{
    const active=new URL(anchor.href,location.href).pathname===location.pathname;
    anchor.classList.toggle('menu-drawer__menu-item--active',active&&anchor.classList.contains('menu-drawer__menu-item'));
    anchor.classList.toggle('header__active-menu-item',active&&anchor.classList.contains('header__menu-item'));
    const span=anchor.querySelector('span');
    if(span&&anchor.classList.contains('header__menu-item')){span.classList.toggle('header__active-menu-item-v2',active);span.classList.toggle('color-accent-1',active);}
    if(active)anchor.setAttribute('aria-current','page');else anchor.removeAttribute('aria-current');
  });
  document.querySelectorAll('.source-gallery media-gallery').forEach((gallery)=>{
    const slides=[...gallery.querySelectorAll('.product__media-list>li')];
    const thumbnails=[...gallery.querySelectorAll('.thumbnail-list button')];
    const list=gallery.querySelector('.product__media-list');
    const thumbnailList=gallery.querySelector('.thumbnail-list');
    const mobile=window.matchMedia('(max-width:749px)');
    const reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
    let current=0;
    const update=()=>{
      slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===current);slide.hidden=!mobile.matches&&i!==current;});
      thumbnails.forEach((button,i)=>{if(i===current)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
      gallery.querySelectorAll('.product-media-slider button[name]').forEach(button=>{button.disabled=button.name==='previous'?current===0:current===slides.length-1;});
    };
    const activate=(index,animate=true)=>{
      current=Math.max(0,Math.min(slides.length-1,index));update();
      if(mobile.matches)list.scrollTo({left:current*list.clientWidth,behavior:animate&&!reduced.matches?'smooth':'instant'});
      const thumb=thumbnails[current]?.closest('li');
      if(thumb){const left=thumb.offsetLeft;if(left<thumbnailList.scrollLeft||left+thumb.offsetWidth>thumbnailList.scrollLeft+thumbnailList.clientWidth)thumbnailList.scrollTo({left:Math.max(0,left-thumbnailList.clientWidth/2+thumb.offsetWidth/2),behavior:reduced.matches?'instant':'smooth'});}
    };
    thumbnails.forEach((button,i)=>button.addEventListener('click',()=>activate(i)));
    gallery.querySelectorAll('.product-media-slider button[name]').forEach((button)=>button.addEventListener('click',()=>activate(current+(button.name==='next'?1:-1))));
    gallery.querySelectorAll('.thumbnail-slider>button[name]').forEach((button)=>button.addEventListener('click',()=>gallery.querySelector('.thumbnail-list').scrollBy({left:(button.name==='next'?1:-1)*300,behavior:'smooth'})));
    let start;
    list.addEventListener('pointerdown',(event)=>{if(event.pointerType==='mouse'){start=event.clientX;list.setPointerCapture(event.pointerId);}});
    list.addEventListener('pointerup',(event)=>{if(start!==undefined&&Math.abs(event.clientX-start)>35)activate(current+(event.clientX<start?1:-1));start=undefined;});
    list.addEventListener('pointercancel',()=>{start=undefined;});
    list.addEventListener('scrollend',()=>{if(mobile.matches){current=Math.round(list.scrollLeft/list.clientWidth);update();}});
    new ResizeObserver(()=>activate(current,false)).observe(list);
    activate(0,false);
  });
  document.querySelectorAll('.review-items-container splide-component').forEach((carousel)=>{
    const shell=carousel.querySelector('.splide');shell.classList.add('is-initialized','is-overflow');
    const list=carousel.querySelector('.splide__list');const slides=[...list.children];const dots=carousel.querySelector('.splide__pagination');
    const track=carousel.querySelector('.splide__track');
    let index=0;
    const show=(next)=>{
      index=Math.max(0,Math.min(slides.length-1,next));
      const gap=Number(window.innerWidth<750?carousel.dataset.gapMobile:carousel.dataset.gapDesktop)||45;
      slides.forEach((slide,i)=>{slide.hidden=false;slide.style.marginRight=`${gap}px`;slide.setAttribute('aria-hidden',String(i!==index));slide.inert=i!==index;});
      list.style.setProperty('--review-offset',`${-index*(list.clientWidth+gap)}px`);
      dots.querySelectorAll('button').forEach((button,i)=>{button.classList.toggle('is-active',i===index);button.setAttribute('aria-current',String(i===index));});
    };
    slides.forEach((slide,i)=>{const li=document.createElement('li');const button=document.createElement('button');button.type='button';button.className='splide__pagination__page';button.setAttribute('aria-label',`Read testimonial ${i+1}`);button.addEventListener('click',()=>show(i));li.append(button);dots.append(li);});
    let start=null;
    track.style.touchAction='pan-y';
    track.addEventListener('pointerdown',event=>{start=event.clientX;track.setPointerCapture(event.pointerId);});
    track.addEventListener('pointerup',event=>{if(start!==null&&Math.abs(event.clientX-start)>30)show(index+(event.clientX<start?1:-1));start=null;});
    track.addEventListener('pointercancel',()=>{start=null;});
    track.addEventListener('dragstart',event=>event.preventDefault());
    new ResizeObserver(()=>show(index)).observe(track);
    show(0);
  });
  const header=document.querySelector('.section-header');
  if(header){
    let last=window.scrollY;
    const updateHeight=()=>document.documentElement.style.setProperty('--header-height',`${header.offsetHeight}px`);
    new ResizeObserver(updateHeight).observe(header);updateHeight();
    window.addEventListener('scroll',()=>{
      const current=window.scrollY;
      const below=current>header.offsetHeight+60;
      header.classList.toggle('shopify-section-header-sticky',below);
      header.classList.toggle('shopify-section-header-hidden',below&&current>last&&!header.querySelector('details[open]'));
      header.classList.toggle('animate',below&&current<last);last=current;
    },{passive:true});
  }
})();
